<template >
  <div class="filter-container">
    <p class="filter-header">Filter by merchant type</p>
  <ais-panel>
    
          <template #default>
            <img 
            class="store-image-icon"
            src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/bnpl-site-cms-dev/Koko-search/shop.png"/>
            <ais-toggle-refinement
              attribute="doesOffline"
              label="Instore Merchants"
            />
          </template>
        </ais-panel>
        
        <ais-panel>
          
          <template #default>
            <img 
            class="store-image-icon"
            src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/bnpl-site-cms-dev/Koko-search/Social.png"/>
            <ais-toggle-refinement
              attribute="doesSocial"
              label="Social Media Merchants"
            />
          </template>
        </ais-panel>
        <ais-panel>
          
          <template #default>
            <img 
            class="store-image-icon"
            src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/bnpl-site-cms-dev/Koko-search/cart.png"/>
            <ais-toggle-refinement
              attribute="doesOnline"
              label="Online Merchants"
            />
          </template>
        </ais-panel>

        <ais-clear-refinements @click="hideFilter">
          <template #resetLabel> Clear </template>
        </ais-clear-refinements>
      </div>
</template>

<script>
import { AisPanel,AisClearRefinements,AisToggleRefinement } from 'vue-instantsearch/vue3/es';
export default {
  props:['showFilterProp'],
  components:{
    AisPanel,AisClearRefinements,AisToggleRefinement
  },
  methods:{
    hideFilter(){
      console.log(this.showFilterProp)
      this.$emit('update:showFilterProp', false);
    }
  },
  data(){
    return{
      // showFilterProp:false
    }
  }
}
</script>

<style>
.ais-ToggleRefinement-checkbox:checked {
  background: #060606;
}
.ais-ToggleRefinement-count{
  display: none;
}
.store-image-icon{
  height: 15px;
  width: auto;
}
.ais-Panel-body{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
}
.filter-container{
  margin-left: 8%;
  margin-right: 8%;
  margin-top: 15px;
  margin-bottom: 24px;
  display: grid;
  justify-content: center;
}
.ais-ToggleRefinement{
  justify-content:space-between;
}
.ais-ToggleRefinement-labelText{
  width: 269px;
    margin-left: 24px;
}
.ais-Panel {
    margin-bottom: 15px;
}
.filter-header{
  font-weight: bold;
  font-size: 15px;
  font-family:raleway;
  color:#A8A6A6;
}
.ais-ClearRefinements{
  display:flex;
  justify-content:flex-end;
}
.ais-ClearRefinements-button--disabled{
  width:51px;
  height: 20px;
  border-radius: 15px;
  font-size: 10px !important;
  color:#3b3a3a !important ;
  display: none;
}
.ais-ClearRefinements-button{
  width:51px;
  height: 20px;
  border-radius: 15px;
  background-color: black !important;
  color: white !important;
  font-size: 10px !important;
}

@media screen and (max-width: 415px){
  .filter-container {
    margin-left: 2%;
    margin-right: 2%;
    
}
}
@media screen and (max-width: 361px) {
  .filter-container {
    margin-left: 0;
    margin-right: 0;
    
}
}
</style>